<template>

    <div class="form-check">
        <input class="form-check-input" type="checkbox" value="" :id="fieldId" v-model="element.value" @input="handleInput">
        <label class="form-check-label" :for="fieldId">{{ element.display_name }}</label>
    </div>

</template>

<script>

export default {

    name: 'PersonalizedGameEditorBool',

    props: {
        value: Object
    },

    data() {
        return {
            element: this.value,
            fieldId: null
        }
    },

    mounted() {
        this.fieldId = this.element.name + this._uid;
    },

    methods: {
        handleInput (e) {
            this.$emit('input', this.element)
        }
    }

}
</script>

<style scoped>

</style>
